import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/business',
    component: () => import('../views/business/BusinessView.vue'),
    redirect: '/business/overview',
    children: [
      { path: 'overview', name: 'business-overview', component: () => import('../views/business/OverViewTab.vue') },
      { path: 'company', name: 'business-company', component: () => import('../views/business/CompanyTab.vue') },
      { path: 'brand', name: 'business-brand', component: () => import('../views/business/BrandTab.vue') },
      { path: 'location', name: 'business-location', component: () => import('../views/business/LocationTab.vue') }
    ]
  },
  {
    path: '/premium',
    component: () => import('../views/premium/PremiumView.vue'),
    redirect: '/premium/location',
    children: [
      { path: 'location', name: 'premium-location', component: () => import('../views/premium/LocationTab.vue') }
    ]
  },
  {
    path: '/complex',
    component: () => import('../views/complex/ComplexView.vue'),
    redirect: '/complex/design',
    children: [
      { path: 'design', name: 'complex-design', component: () => import('../views/complex/DesignTab.vue') }
    ]
  },
  {
    path: '/unit',
    component: () => import('../views/unit/UnitView.vue'),
    redirect: '/unit/type',
    children: [
      { path: 'type', name: 'unit-type', component: () => import('../views/unit/TypeTab.vue') },
      { path: 'community', name: 'unit-community', component: () => import('../views/unit/CommunityTab.vue') }
    ]
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/support/SupportView.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.path.startsWith('/business') && from.path.startsWith('/business')) return false
    if (to.path.startsWith('/premium') && from.path.startsWith('/premium')) return false
    if (to.path.startsWith('/complex') && from.path.startsWith('/complex')) return false
    if (to.path.startsWith('/unit') && from.path.startsWith('/unit')) return false
    if (savedPosition) return savedPosition
    return { top: 0 }
  }
})

export default router
